import { useContext } from 'react';
import { BrandContext } from '../context/BrandContext.js';
import type { BrandConfig } from '../types/index.js';

/**
 * Access the current brand configuration from context.
 * Must be used within a BrandProvider.
 */
export function useBrand(): BrandConfig {
  const ctx = useContext(BrandContext);
  if (!ctx) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return ctx;
}
